/* eslint-disable import/no-anonymous-default-export */

const config = {URL: process.env.REACT_APP_API_URL};

export default config;
